function girlSuitGeneral(){
    this.typeConf={
        "1":{name:"shirt"},
        "2":{name:"shoes"},
        "3":{name:"bra"},
        "4":{name:"dress"},
        "5":{name:"skirt"},
        "6":{name:"pants"},
        "7":{name:"trousers"},
        "8":{name:"tights"},
        "9":{name:"tights_set"},
        "10":{name:"corset"},
        "11":{name:"overall"},
        "12":{name:"special"},
        "13":{name:"coat"},
        "14":{name:"cap"},
        "15":{name:"glasses"},
        "16":{name:"neck"},
        "17":{name:"hand"},
        "18":{name:"leg"},
        "19":{name:"ring"},
        "20":{name:"earrings"},
        "21":{name:"gloves"}
    };
    this.girl2suit={"1":"123",
        "2":"124",
        "3":"125",
        "4":"126",
        "5":"127",
        "6":"128",
        "7":"129",
        "8":"130",
        "9":"131",
        "10":"132",
        "11":"133",
        "12":"134",
        "13":"135",
        "14":"136",
        "15":"137",
        "16":"264",
        "17":"265",
        "18":"316",
        "19":"430"
    };
    this.suitOrder=[
        ["pants","tights_set","tights","leg","bra","corset","trousers","overall","skirt","dress","shirt","hand","coat","shoes","ring","gloves","earrings"],
        ["special","neck","glasses","cap"]
    ];



}
girlSuitGeneral.prototype={
    takeName:function(type_id){
        return this.typeConf[type_id].name;
    },
    takePvPSuitId:function(girl_id){
        if(typeof this.girl2suit[girl_id]!="undefined"){
            return this.girl2suit[girl_id];
        }
        return 0;
    },
    takeTypeId:function(name){
        var i;
        for(i in this.typeConf){
            if(this.typeConf[i].name==name){
                return intval(i);
            }
        }
        return 0;
    },
    takeOrderArr:function(type){
        var i,name,ready=[];
        for(i in this.suitOrder[type]){
            name=this.suitOrder[type][i];
            ready.push(this.takeTypeId(name));
        }
        return ready;
    }
};
_girlSuitGeneral = new girlSuitGeneral();

function girlSuitView(girl_id,active_obj){
    this.girl_id=girl_id;
    this.active_obj=copyObj(active_obj);
    this.girl_name=$.takeGirlImage(girl_id);
    this.timeHandleIndexArr={eye:_moduleTimeHandler.getNewIndex(),back:_moduleTimeHandler.getNewIndex()};

}
girlSuitView.prototype={
    updateActive:function(active_obj){
        this.active_obj=copyObj(active_obj);
    },
    takeGirlPath:function(not_show){
        var suffix="";
        if(not_show){
            suffix="_un";
        }
        return _IMG_SERV+"/gfx/girlsuit/"+this.girl_name+"/girl"+suffix+".png"+$.takeGirlVersion(this.girl_id);
    },
    takeSuitPath:function(suit_id){
        return _IMG_SERV+"/gfx/girlsuit/"+this.girl_name+"/"+suit_id+".png"+$.takeGirlVersion(this.girl_id);
    },
    takeSuitIconPath:function(suit_id){
        return _IMG_SERV+"/gfx/girlsuit/"+this.girl_name+"/"+suit_id+"_ico.png"+$.takeGirlVersion(this.girl_id);
    },

    takeEyeUrl:function(state,only_url){
        var url="none";
        if(state==1){
            url=_IMG_SERV+"/gfx/girlsuit/"+this.girl_name+"/eye1.png"+$.takeGirlVersion(this.girl_id);
        }
        if(state==2){
            url=_IMG_SERV+"/gfx/girlsuit/"+this.girl_name+"/eye2.png"+$.takeGirlVersion(this.girl_id);
        }
        if(url!="none" && !only_url){
            url="url("+url+")";
        }
        return url;
    },
    makeView:function(objJQ,not_show){
        var allImages=[[],[]];
        allImages[0].push({path:this.takeGirlPath(not_show),left:0,top:0});
        var k_max=0;
        if(!not_show){
            var orderArr,type_id,suit_id,i,k;
            for(k=0;k<=1;k++){
                orderArr=_girlSuitGeneral.takeOrderArr(k);
                for(i in orderArr){
                    type_id=orderArr[i];
                    if(typeof this.active_obj[type_id]!="undefined" && this.active_obj[type_id]){
                        allImages[k].push({path:this.takeSuitPath(this.active_obj[type_id]),left:0,top:0});
                    }
                }
                if(allImages[k].length){
                    k_max++;
                }
            }

        }
        k_max=Math.max(1,k_max);
        objJQ.find(".layer").remove();
        objJQ.addClass("girlWhole").css({'opacity':0}).show();
        var k,layer,wasLoaded=0;
        var addToPreloader=[];
        this.addBackAnimPreloader(addToPreloader);

        for(k in allImages){
            objJQ.append("<div class='layer'></div>");
            layer=objJQ.find(".layer").last();
            if(allImages[k].length){
                layer.myBackgroundImage(
                    {onEnd:function(){
                            wasLoaded++;
                            if(wasLoaded==k_max){
                                if(addToPreloader.length){
                                    $("<div/>").one("myload",function(){
                                        objJQ.animate({'opacity':1},500);
                                    }).myLoad(addToPreloader);
                                }
                                else{
                                    objJQ.animate({'opacity':1},500);
                                }

                            }
                        }
                    },allImages[k]);
            }
        }

        if(!not_show){
            this.makeEyeAnim(objJQ);
            this.makeBackAnim(objJQ);
        }
    },
    addBackAnimPreloader:function(addToPreloader){
        var conf=$.takeGirlConf(this.girl_id,"anim_back");
        if(typeof conf.clips=="undefined"){
            return false;
        }
        var i;
        for(i=0;i<conf.clips;i++){
            addToPreloader.push(_IMG_SERV+"/gfx/girlsuit/"+this.girl_name+"/anim_back"+i+".png");
        }
    },
    makeBackAnim:function(objJQ){
        var conf=$.takeGirlConf(this.girl_id,"anim_back");
        if(typeof conf.clips=="undefined"){
            return false;
        }
        conf.clips--;
        var timeHandlerIndex=this.timeHandleIndexArr.back;
        _moduleTimeHandler.clear(timeHandlerIndex);
        objJQ.find(".animback").remove();




        objJQ.prepend("<div class='animback'></div>");
        var backObj=objJQ.find(".animback");
        var qth=this;
        conf.onStep=function(step){
            backObj.css("background-image","url("+_IMG_SERV+"/gfx/girlsuit/"+qth.girl_name+"/anim_back"+step+".png)");
        };
        objJQ.find(".animback").qAnim(conf);
    },
    makeEyeAnim:function(objJQ){
        var timeHandlerIndex=this.timeHandleIndexArr.eye;
        _moduleTimeHandler.clear(timeHandlerIndex);

        var eyeStat={"0":this.takeEyeUrl(0),"1":this.takeEyeUrl(1),"2":this.takeEyeUrl(2)};
        objJQ.find(".eye").remove();
        objJQ.find(".layer").eq(0).after("<div class='eye'></div>");
        var obj=objJQ.find(".eye");
        $("<div/>").one("myload",function(){

            var img_max=2,step=mt_rand(-5,-3),step_max=mt_rand(10,40);
            var img_last=-1;
            _moduleTimeHandler.set(timeHandlerIndex,function(){
                step++;
                var img=step;
                if(img>img_max*2-1){
                    img=0;
                }
                else if(img>img_max){
                    img=img_max-Math.abs(img-img_max);
                }
                if(step>=step_max){
                    step=-1;
                    step_max=mt_rand(10,40);
                }
                if(img_last!=img){
                    img_last=img;
                    obj.css("background-image",eyeStat[img]);
                }
            },100);
        }).myLoad([this.takeEyeUrl(1,1),this.takeEyeUrl(2,1)]);
    },
    isWearing:function(suit_id,type_id){
        if(typeof this.active_obj[type_id]!="undefined" && this.active_obj[type_id]==intval(suit_id)){
            return 1;
        }
        return 0;
    },
    canWear:function(type_id,block_conf){
        var blockNames=block_conf[type_id].block,blockObj={},block_count=0;
        var i,name,ctype_id;
        if(typeof this.active_obj[type_id]!="undefined" && typeof this.active_obj[type_id]){
            block_count++;
            blockObj[type_id]=this.active_obj[type_id];
        }
        for(i in blockNames){
            name=blockNames[i];
            ctype_id=_girlSuitGeneral.takeTypeId(name);
            if(typeof this.active_obj[ctype_id]!="undefined" && typeof this.active_obj[ctype_id]){
                block_count++;
                blockObj[ctype_id]=this.active_obj[ctype_id];
            }
        }
        if(block_count==0){
            return true;
        }
        return copyObj(blockObj);
    }
};